import * as tslib_1 from "tslib";
import { FEET, KILOMETERS, LENGTH, METERS, NAUTICAL_MILES, STATUTE_MILES } from '../units';
import { BaseConverter } from './base-converter';
/**
 * Conversion factor for distance in meters to feet
 */
export var M_TO_FT = 3.28084;
/**
 * Conversion factor for distance in meters to kilometers
 */
export var M_TO_KM = 0.001;
/**
 * Conversion factor for distance in meters to nautical miles
 */
export var M_TO_NM = 0.000539957;
/**
 * Conversion factor for distance in meters to nautical miles
 */
export var M_TO_SM = 0.000621371;
/**
 * Length unit converter class
 */
var LengthConverter = /** @class */ (function (_super) {
    tslib_1.__extends(LengthConverter, _super);
    function LengthConverter() {
        var _this = _super.call(this, LENGTH) || this;
        _this._baseUnit = METERS;
        _this._conversionFactors.set(FEET, M_TO_FT);
        _this._conversionFactors.set(KILOMETERS, M_TO_KM);
        _this._conversionFactors.set(NAUTICAL_MILES, M_TO_NM);
        _this._conversionFactors.set(STATUTE_MILES, M_TO_SM);
        _this._check();
        return _this;
    }
    return LengthConverter;
}(BaseConverter));
export { LengthConverter };
/**
 * Length unit converter singleton
 */
export var LENGTH_CONVERTER = new LengthConverter();
